import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';

var incrementMapping = {
  forward: 1,
  back: -1,
  remain: 0,
  skipTo: Number.NaN
};
/** Represents the the type of change in a FilmstripPageChange */

var FilmstripPageChangeType;

(function (FilmstripPageChangeType) {
  FilmstripPageChangeType["forward"] = "forward";
  FilmstripPageChangeType["back"] = "back";
  FilmstripPageChangeType["remain"] = "remain";
  FilmstripPageChangeType["skipTo"] = "skipTo";
})(FilmstripPageChangeType || (FilmstripPageChangeType = {}));
/* represents the cause of a navigation event */


var FilmstripNavigationCause;

(function (FilmstripNavigationCause) {
  FilmstripNavigationCause["api"] = "api";
  FilmstripNavigationCause["button"] = "button";
  FilmstripNavigationCause["pager"] = "pager";
  FilmstripNavigationCause["resize"] = "resize";
  FilmstripNavigationCause["swipe"] = "swipe";
})(FilmstripNavigationCause || (FilmstripNavigationCause = {}));
/** A little type guard to make differentiation more readable */


function isNum(thing) {
  return typeof thing === 'number';
}

var FilmstripPageChange = /*#__PURE__*/function () {
  function FilmstripPageChange(changeRequest, cause, oldPage) {
    _classCallCheck(this, FilmstripPageChange);

    this.cause = cause;
    this.oldPage = oldPage; // If pageNumberOrDelta is a number, we're skipping directly to a page.

    this.type = isNum(changeRequest) ? FilmstripPageChangeType.skipTo : changeRequest;
    this.newPage = this.newPageFrom(changeRequest);
  }
  /** Get the new page number according to a change request */


  _createClass(FilmstripPageChange, [{
    key: "newPageFrom",
    value: function newPageFrom(request) {
      // If pageNumberOrDelta is a number, we're skipping directly to a page.
      return isNum(request) ? request : this.oldPage + incrementMapping[request];
    }
  }, {
    key: "createEvent",

    /** Create and return a CustomEvent that passes a FilmstripPageChange object, containing everything one needs to know about the change of a page. */
    value: function createEvent() {
      return new CustomEvent('pagechanged', {
        detail: this
      });
    }
  }, {
    key: "noChange",
    get: function get() {
      return this.oldPage === this.newPage;
    }
  }]);

  return FilmstripPageChange;
}();

export { FilmstripNavigationCause, FilmstripPageChange, FilmstripPageChangeType };
